import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e104b31e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick", "aria-pressed", "title"]
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "icons" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.99998 3.33331V12.6666M7.99998 12.6666L12.6666 7.99998M7.99998 12.6666L3.33331 7.99998",
    stroke: "#475467",
    "stroke-width": "1.33333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "sort-icon-inactive",
  "aria-hidden": "true"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.66675 9.99996L8.00008 13.3333L11.3334 9.99996M4.66675 5.99996L8.00008 2.66663L11.3334 5.99996",
    stroke: "#667085",
    "stroke-width": "1.33",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "header-label"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["colspan"]

import { computed, ref, watch } from "vue";
import type { PropType } from "vue";
import LingoTooltipIcon from "@/modules/main/components/manage/LingoTooltipIconComponent.vue";

type Column = {
  key: string;
  label?: string;
  title?: string;
  width?: string;
  sortable?: boolean;
  tooltip?: string;
  prependSlot?: string;
  formatter?: (val: any, item?: any) => string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'LingoDataTableComponent',
  props: {
  items: { type: Array as PropType<any[]>, default: () => [] },
  columns: { type: Array as PropType<Column[]>, required: true },
  sortKey: { type: String, default: "" },
  sortDir: { type: String, default: "asc" },
  rowKey: { type: [String, Function] as PropType<string | ((item: any) => string)>, default: "id" },
  tableClass: { type: String, default: "" },
},
  emits: ["update:sortKey", "update:sortDir", "sort-change"],
  setup(__props, { emit }) {

const props = __props;





const internalSortKey = ref<string>(
  props.sortKey || (props.columns.find((c) => c.sortable) && props.columns.find((c) => c.sortable)!.key) || ""
);
const internalSortDir = ref<string>(props.sortDir === "desc" ? "desc" : "asc");

watch(
  () => props.sortKey,
  (v) => {
    internalSortKey.value = v;
  }
);
watch(
  () => props.sortDir,
  (v) => {
    internalSortDir.value = v === "desc" ? "desc" : "asc";
  }
);

const sortedItems = computed(() => {
  const arr = Array.isArray(props.items) ? [...props.items] : [];
  const key = internalSortKey.value;
  const dir = internalSortDir.value === "asc" ? 1 : -1;
  if (!key) return arr;

  arr.sort((a: any, b: any) => {
    const va = a == null ? null : a[key];
    const vb = b == null ? null : b[key];

    if (va == null && vb == null) return 0;
    if (va == null) return 1 * dir;
    if (vb == null) return -1 * dir;

    const na = Number(va);
    const nb = Number(vb);
    if (!isNaN(na) && !isNaN(nb)) {
      return (na - nb) * dir;
    }

    const sa = String(va).toLowerCase();
    const sb = String(vb).toLowerCase();
    if (sa < sb) return -1 * dir;
    if (sa > sb) return 1 * dir;
    return 0;
  });

  return arr;
});

function toggleSort(key: string) {
  if (internalSortKey.value === key) {
    internalSortDir.value = internalSortDir.value === "asc" ? "desc" : "asc";
  } else {
    internalSortKey.value = key;
    internalSortDir.value = "asc";
  }
  emit("update:sortKey", internalSortKey.value);
  emit("update:sortDir", internalSortDir.value);
  emit("sort-change", { key: internalSortKey.value, dir: internalSortDir.value });
}

function displayValue(v: any) {
  if (v == null) return "-";
  return v;
}

function rowKeyFn(item: any, idx: number) {
  if (typeof props.rowKey === "function") return (props.rowKey as (i: any) => string)(item);
  return item && item[(props.rowKey as string)] != null ? item[(props.rowKey as string)] : idx;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["lingo-data-table", __props.tableClass])
  }, [
    _createElementVNode("table", null, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (col) => {
            return (_openBlock(), _createElementBlock("th", {
              key: col.key,
              style: _normalizeStyle({ width: col.width || 'auto' }),
              class: _normalizeClass({ sortable: col.sortable })
            }, [
              (col.tooltip)
                ? (_openBlock(), _createBlock(LingoTooltipIcon, {
                    key: 0,
                    class: "header-tooltip",
                    text: col.tooltip,
                    ariaLabel: col.label,
                    placement: "top"
                  }, null, 8, ["text", "ariaLabel"]))
                : _createCommentVNode("", true),
              (col.sortable)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "header-btn",
                    onClick: ($event: any) => (toggleSort(col.key)),
                    "aria-pressed": internalSortKey.value === col.key,
                    title: col.title || col.label
                  }, [
                    _createElementVNode("span", _hoisted_2, [
                      (col.prependSlot)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                            _renderSlot(_ctx.$slots, col.prependSlot)
                          ]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(col.label), 1)
                    ]),
                    _createElementVNode("span", _hoisted_4, [
                      (internalSortKey.value === col.key)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass([
                    'sort-icon',
                    {
                      asc: internalSortKey.value === col.key && internalSortDir.value === 'asc',
                      desc: internalSortKey.value === col.key && internalSortDir.value === 'desc'
                    }
                  ])
                          }, _hoisted_6, 2))
                        : (_openBlock(), _createElementBlock("span", _hoisted_7, _hoisted_9))
                    ])
                  ], 8, _hoisted_1))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(col.label), 1))
            ], 6))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedItems.value, (item, rowIndex) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: rowKeyFn(item, rowIndex)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (col) => {
              return (_openBlock(), _createElementBlock("td", {
                key: col.key
              }, [
                _renderSlot(_ctx.$slots, `cell-${col.key}`, {
                  item: item,
                  index: rowIndex
                }, () => [
                  (col.formatter)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(col.formatter(item[col.key], item)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(displayValue(item[col.key])), 1))
                ])
              ]))
            }), 128))
          ]))
        }), 128)),
        (!sortedItems.value.length)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
              _createElementVNode("td", {
                colspan: __props.columns.length,
                class: "empty"
              }, "No items", 8, _hoisted_14)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})